import { NgxZendeskWebwidgetConfig } from '@nitsanzo/ngx-zendesk-webwidget';

export class ZendeskConfig extends NgxZendeskWebwidgetConfig {
  lazyLoad = true;
  accountUrl = 'odilotid.zendesk.com';

  callback(zE: any): void {}
}
